<template>
  <template v-if="tripfinderViewModel">
    <facet-search-bar-large
      v-if="
        tripfinderViewModel.filter.largeFilter &&
        tripfinderViewModel.filter.filters.length
      "
    />
    <facet-search-bar
      v-else-if="
        !tripfinderViewModel.filter.largeFilter &&
        tripfinderViewModel.filter.filters.length
      "
    />
    <template
      v-if="
        tripfinderViewModel.paging.items.length === 1 &&
        tripfinderViewModel.paging.items[0].documentType === 'PageCruise'
      "
    >
      <div :class="getRowBackgroundClass() + ' py-5'">
        <tripfinder-result-list-view
          :pagingItem="tripfinderViewModel.paging.items[0]"
          :index="0"
        />
      </div>
    </template>
    <template
      v-for="(item, index) in tripfinderViewModel.paging.items"
      :key="index"
      v-else
    >
      <div
        :class="getRowBackgroundClass() + ' py-5'"
        v-if="item.totalNumberOfResults > 0"
      >
        <tripfinder-result-card-view
          :pagingItem="item"
          :index="index"
          v-if="documentType !== 'PageCruise'"
        />
      </div>
    </template>
    <button
      type="button"
      id="btnToFilters"
      class="btn btn-yellow rounded-pill"
      @click="scrollToFacets"
      hidden
    >
      Til søgefiltre
    </button>
  </template>
</template>
<script>
import FacetSearchBar from "./FacetSearchBar.vue";
import FacetSearchBarLarge from "./FacetSearchBarLarge.vue";
import FacetDropdownListItem from "./FacetDropdownListItem.vue";
import TripfinderResultListView from "./TripfinderResultListView.vue";
import TripfinderResultCardView from "./TripfinderResultCardView.vue";
export default {
  name: "TripfinderResults",
  props: [],
  components: {
    FacetSearchBar,
    FacetSearchBarLarge,
    FacetDropdownListItem,
    TripfinderResultListView,
    TripfinderResultCardView,
  },
  computed: {
    tripfinderViewModel() {
      return this.$store.state.tripfinderViewModel;
    },
    tripfinderResult() {
      return this.$store.state.tripfinderResult;
    },
  },
  mounted() {
    const tripfinderHero = document.getElementById("tripfinderHero");
    if (tripfinderHero) tripfinderHero.classList.add("d-none");

    const facetCheck = document.getElementById("facetCheck");
    if (facetCheck) {
      const btnScroll = document.getElementById("btnToFilters");
      document.addEventListener(
        "scroll",
        (event) => {
          const facetCheckBottom = facetCheck.getBoundingClientRect().bottom;
          if (facetCheckBottom < 0) {
            btnScroll.removeAttribute("hidden");
          } else {
            btnScroll.setAttribute("hidden", true);
          }
        },
        { passive: true }
      );
    }
    this.scrollToFacets();
  },
  methods: {
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
    getRowBackgroundClass() {
      return "bg__" + this.tripfinderViewModel.backgroundColorBottom;
    },
    getMoreResultItems: function (index) {
      this.$store.dispatch("getMoreResultItems", index);
    },
    scrollToFacets: function () {
      const facetHeader = document.getElementById("facetHeader");
      if (facetHeader) facetHeader.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>